import { addDate } from 'lib/date';
import { AccountRate, RateStatus } from 'services/enums';
import { DocumentsCountValue } from 'types/billing';

import {
    DASH_SIGN_RATES,
    INFINITY_SIGN_RATES,
    trialWebOrApiRates,
} from './constants';

export const isComparedFilterStatuses = (
    statuses: RateStatus[],
    activeFilters: RateStatus[],
) => {
    return (
        statuses.length === activeFilters.length &&
        statuses.every((value, index) => value === activeFilters[index])
    );
};

export const composeEndRateDate = (
    date: Nullable<Date>,
    rate: AccountRate,
): Nullable<Date> => {
    if (!date) return null;

    if (trialWebOrApiRates.includes(rate)) {
        return addDate(date, 14, 'day');
    }
    return addDate(addDate(date, 1, 'year'), -1, 'day');
};

export const normalizeDocumentsCount = (value: DocumentsCountValue): string => {
    const { rate, units, unitsLeft } = value;

    const infinity = '∞';
    const dash = '-';

    if (INFINITY_SIGN_RATES.includes(rate)) return infinity;

    if (DASH_SIGN_RATES.includes(rate)) return dash;

    return `${unitsLeft}/${units}`;
};
